export interface ServiceColorMap {
  'Deep Cleaning': string;
  'Move Out Cleaning': string;
  'Window Cleaning': string;
  'Free Estimate': string;
  'Refrigerator Cleaning': string;
  'Post Construction Cleaning': string;
  'Recurring Cleaning': string;
  'Oven Cleaning': string;
  'AirBnb Cleaning Service': string;
  'Commercial Cleaning': string;
  'Office Cleaning': string;
  'Other': string; // Fallback for unknown/blocked
}

export const serviceColorMap: ServiceColorMap = {
  'Deep Cleaning':              '#5C6BC0', // indigo blue
  'Move Out Cleaning':          '#EC407A', // hot pink
  'Window Cleaning':            '#F48FB1', // light pink
  'Free Estimate':              '#26A69A', // teal
  'Refrigerator Cleaning':      '#43A047', // green
  'Post Construction Cleaning': '#42A5F5', // sky blue
  'Recurring Cleaning':         '#7986CB', // lavender
  'Oven Cleaning':              '#7E57C2', // purple
  'AirBnb Cleaning Service':    '#C8A96E', // tan/khaki
  'Commercial Cleaning':        '#FF7043', // deep orange
  'Office Cleaning':            '#26C6DA', // cyan
  'Other':                      '#78909C', // blue-grey
};

export interface AdditionalService {
  type: ServiceType;
  thumbnail: string;
}

export interface ApiServiceResponse {
  _id?: string;
  serviceId?: string; // Wix Bookings unique service ID
  appId?: string; // Wix Bookings service UUID
  name?: string;
  type?: string;
  title?: string;
  serviceName?: string;
  description?: string;
  imageDownloadUrl?: string;
  downloadUrl?: string;
  image?: string;
  thumbnail?: string;
  imageUrl?: string;
  mainImage?: {
    url?: string;
  };
  coverImage?: {
    url?: string;
  };
  mainMedia?: {
    image?: string;
    url?: string;
  };
  coverMedia?: {
    image?: string;
    url?: string;
  };
  media?: {
    mainMedia?: {
      image?: string;
      url?: string;
    };
    coverMedia?: {
      image?: string;
      url?: string;
    };
    mainImage?: {
      url?: string;
    };
    coverImage?: {
      url?: string;
    };
    items?: Array<{
      image?: string;
      url?: string;
    }>;
  };
}

export type ServiceType = keyof typeof serviceColorMap;

export const getServiceColor = (serviceType: ServiceType): string => {
  return serviceColorMap[serviceType];
};

export interface ServiceInfo {
  type: ServiceType;
  imageUrl: string;
  uniqueKey?: string;
  appId?: string; // Wix Bookings service UUID
  serviceId?: string; // Wix Bookings unique service ID
  defaultDuration?: number; // Default duration in minutes from Wix
}

export interface ServiceTypeModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  onSelectServiceType?: (serviceType: ServiceType, imageUrl: string) => void;
  selectedServiceType?: ServiceType | '';
  services?: ServiceInfo[];
  loading?: boolean;
  /**
   * Render as a routed page (an <IonPage>) instead of a self-contained
   * <IonModal>. In page mode the component loads its own service list and
   * opens its own booking form when a service is chosen — the isOpen /
   * services / loading / onSelectServiceType props are ignored.
   */
  asPage?: boolean;
}